import {writable} from 'svelte/store';

let ordersObject = {
    list: null,
    total: 0,
    total_samples: 0,
    selectedId: null,
    orderIsDirty: false,

    search: {
        date_from: null,
        date_to: null,
        code: null,
        sample_code: null,
        client_term: null,
        client_id: null,
        offset: 0,
        limit: null,
        sort_field: null,
        sort_way: null,
    },

    changed: false,
    scrollY: null,
};

const {get, set, update, subscribe} = writable(ordersObject);

const orders = {
    set,
    update,
    subscribe,

    clearSearch: () => {
        orders.update(obj => {
            obj.search.date_from = null;
            obj.search.date_to = null;
            obj.search.code = null;
            obj.search.sample_code = null;
            obj.search.client_term = null;
            obj.search.client_id = null;
            obj.search.offset = 0;

            obj.page = 1;
            return obj;
        });
    }
}

export default orders;